import { useState } from "react";
import { FlaskConical } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import CalibrationDialog from "@/components/laser/CalibrationDialog";

const KEYS = ["substrate_detail", "contaminant", "power_percent", "frequency_khz", "pulse_width_ns", "speed_mm_s", "pattern_size_mm", "hatch_1_mm", "hatch_2_mm", "focal_distance_mm", "passes", "metal_thickness_mm"];

export default function LogTestFromChat({ data, substrate, pattern }) {
  const [machines, setMachines] = useState(null);
  const [open, setOpen] = useState(false);
  const start = async () => {
    try {
      const list = await api("/laser/machines");
      if (!list.length) {
        toast("Add your machine first", { description: "Then you can log this setting as a test piece.", action: { label: "Add machine", onClick: () => { window.location.href = "/laser-machines"; } } });
        return;
      }
      setMachines(list); setOpen(true);
    } catch (e) { toast.error(e.message); }
  };
  const prefill = { ...Object.fromEntries(KEYS.map((k) => [k, data[k]])), substrate_category: substrate, pattern, notes: "" };
  const watts = parseInt(data.laser_model, 10);
  const sorted = (machines || []).slice().sort((a, b) => (b.watts === watts) - (a.watts === watts));
  return (
    <>
      <button onClick={start} data-testid="cleaning-settings-log-test-btn" aria-label="Log a test piece with these settings"
        className="flex items-center gap-1 rounded-lg border px-2.5 py-1.5 transition-colors hover:bg-[#4CCC06]/10" style={{ borderColor: "#4CCC06" }}>
        <FlaskConical size={14} color="#4CCC06" /><span style={{ color: "#4CCC06", fontSize: 11, fontWeight: 900, letterSpacing: 0.8 }}>LOG TEST</span>
      </button>
      {open && <CalibrationDialog open={open} onOpenChange={setOpen} machines={sorted} prefill={prefill} requireMedia source="chat" />}
    </>
  );
}
